import { ref } from 'vue'
// types
import type { Ref } from 'vue'

interface BlockFaqGroupHookReturn {
  refOpenIndexes: Ref<Set<number>>
  handleToggle: (index: number) => void
}

export const useBlockFaqGroup = (): BlockFaqGroupHookReturn => {
  const refOpenIndexes = ref<Set<number>>(new Set())

  const handleToggle = (index: number): void => {
    if (refOpenIndexes.value.has(index)) {
      refOpenIndexes.value.delete(index)
    } else {
      refOpenIndexes.value.add(index)
    }
  }

  return {
    refOpenIndexes,
    handleToggle,
  }
}